module.exports = __webpack_public_path__ + "img/haus.2b082d94.jpg";